import HomeLayout from "src/Vistas/LayOuts/HomeLayout.vue";
import VistasAuthLayout from "src/Vistas/LayOuts/AuthLayout.vue";
// GeneralViews
import PaginaNoEncontrada from "src/Vistas/Main/PaginaNoEncontrada.vue";

let authVistas = {
  path: "/",
  component: VistasAuthLayout,
  name: "Authentication",
  children: [

    {
      path: "/login/:SuscripcionID",
      name: "Inicio de sesión",
      component: () =>
        import(
          /* webpackChunkName: "usuarios" */ "src/Vistas/Main/InicioSesion.vue"
        ),
    },
  ]
}
// GeneralViews
const routes = [
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "default" */ "src/pages/Comedor/Vista_compl/index.vue"),
  },
  {
    path: "/cheked",
    name: "Cheked", 
    component: () =>
      import(/* webpackChunkName: "default" */ "src/pages/Comedor/Vista_tablet/index.vue"),
  },
  {
    path: "/",
    name: "Default",
    component: () =>
      import(/* webpackChunkName: "default" */ "src/Vistas/Main/Default.vue"),
  },
  
  authVistas,
  // Agregar código para mostrar vacio
  { path: "*", name: "Página no encontrada", component: PaginaNoEncontrada },
];

export default routes;
